import React, { Component } from 'react';
import PropTypes from 'prop-types';
import oget from 'oget';
import NoProfileImage from '../../../header/images/no-profile-image.jpg';

const PROFILES_URL = process.env.REACT_APP_PROFILES_URL;

export default class TimedRow extends Component {
  static propTypes = {
    groupNumber: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
    colors: PropTypes.object.isRequired,
    athlete: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    columns: PropTypes.object.isRequired,
    onRowRef: PropTypes.func.isRequired,
    showHeadshotsInLeaderboard: PropTypes.bool,
    eventId: PropTypes.any,
  };

  render() {
    const {
      groupNumber,
      rowNumber,
      style,
      noStyle,
      nameStyle,
      scoreStyle,
      colors,
      columns,
      athlete,
      data,
      onRowRef,
      showHeadshotsInLeaderboard,
      eventId,
    } = this.props;

    const info = oget(athlete, 'details.ColumnInformation.values[0].Value');

    return (
      <div
        key={`leaderboard_timed_row_${groupNumber}_${rowNumber}`}
        className="row row-timed"
        style={style}
        ref={(ref) => onRowRef(ref, this.props)}
      >
        <div className="cell cell-no" style={noStyle}>
          {data.rank}
        </div>

        {showHeadshotsInLeaderboard && (
          <div className="cell cell-headshot">
            <img
              src={`${PROFILES_URL}/${eventId}/${athlete.filename}`}
              onError={(e) => {
                e.target.src = NoProfileImage;
              }}
              alt=""
            />
          </div>
        )}

        {columns.Bib && <div className="cell cell-bib">{data.bib}</div>}

        <div className="cell cell-name">
          <div style={nameStyle}>
            {athlete.fullName}
            {columns.Nation && <div className="nation">{athlete.nationality}</div>}
          </div>
        </div>

        <div className="cell cell-scores" style={rowNumber > 0 ? colors.scores.runnersUp : {}}>
          <div className="score-item" style={scoreStyle}>
            {info}
          </div>
        </div>
      </div>
    );
  }
}
